
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/plans-des-pistes",
      function () {
        return require("private-next-pages/[region]/[resort]/plans-des-pistes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/plans-des-pistes"])
      });
    }
  